import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem } from "../../../../hooks/useInventoryState";
import { useStorefrontSettingsState } from "../../../../hooks/useStorefrontSettingsState";
import { useTranslate } from "../../../../hooks/useTranslate/useTranslate";

export type ProductDetailsPackageItemAvailabilityProps = {
	packageItem: ImmutableObject<PackageItem>;
};
export const ProductDetailsPackageItemAvailability: React.FC<
	ProductDetailsPackageItemAvailabilityProps
> = (props) => {
	const translate = useTranslate();
	const packageItem = props.packageItem;
	const totalIn = packageItem.Availability?.TotalIn ?? 0;

	const storefrontSettingsState = useStorefrontSettingsState();
	const showOwnedQty =
		storefrontSettingsState.get().settings?.ShowOwnedQty ?? false;
	let available = "";
	if (totalIn > 0) {
		available += (packageItem.Availability?.TotalIn ?? 0).toString();
		if (showOwnedQty) {
			available += ` ${translate("of")} ${(packageItem.Availability?.Total ?? 0).toString()}`;
		}
		available += ` ${translate("available")}`;
	} else {
		available = translate("Unavailable");
	}

	return (
		<>
			{packageItem.Availability && (
				<div className="field availability text-muted-foreground whitespace-nowrap text-xs flex justify-center">
					({available})
				</div>
			)}
		</>
	);
};
